import { render, staticRenderFns } from "./PersonalAwayApplicationTable.vue?vue&type=template&id=21c6e741&scoped=true&"
import script from "./PersonalAwayApplicationTable.vue?vue&type=script&lang=js&"
export * from "./PersonalAwayApplicationTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c6e741",
  null
  
)

export default component.exports